/**
 * Limits on statement PDFs the AI reads.
 *
 * Kept here rather than beside the upload screens so the shared help tooltip in `components` can
 * reference the same number without depending on `views`. The limit appears in several pieces of
 * user-facing copy, so both the guard and that copy derive from these.
 */
export const MAX_UPLOAD_MB = 30

export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1000 * 1000

export const MAX_UPLOAD_SIZE_TEXT = `Maximum file size: ${MAX_UPLOAD_MB} MB`
